import mercedesDefault from "@/assets/products_mercedes_default.jpg";
import manDefault from "@/assets/products_man_default.jpg";
import mercedesAtego from "@/assets/products_mercedes_ACM_Atego.avif";

export interface Product {
  id: string;
  slug: string;
  title: string;
  manufacturer: "Mercedes-Benz" | "MAN";
  model: string;
  euro: string;
  engine: string;
  kw: number | null;
  sku: string;
  otherReferences: string;
  category: string;
  description: { pl: string; en: string; de?: string };
  image?: string;
  imageBackground?: string;
  createdAt: string;
  popularity: number;
}

export const products: Product[] = [
  {
    id: "1",
    slug: "mercedes-axor-a0714471840-0714471840",
    title: "Mercedes Axor A0714471840 0714471840",
    manufacturer: "Mercedes-Benz",
    model: "Axor",
    euro: "III",
    engine: "OM457hLA",
    kw: 260,
    sku: "A0714471840",
    otherReferences: "0714471840",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika do Mercedes Axor z silnikiem OM457hLA, Euro III, 260 KW. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for Mercedes Axor with OM457hLA engine, Euro III, 260 KW. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für Mercedes Axor mit OM457hLA Motor, Euro III, 260 KW. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2025-12-01",
    popularity: 95,
    image: mercedesDefault,
  },
  {
    id: "2",
    slug: "mercedes-axor-a0724471940-0044462340",
    title: "Mercedes Axor A0724471940 0044462340",
    manufacturer: "Mercedes-Benz",
    model: "Axor",
    euro: "IV",
    engine: "OM457LA",
    kw: 295,
    sku: "A0724471940",
    otherReferences: "0044462340",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika do Mercedes Axor z silnikiem OM457LA, Euro IV, 295 KW. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for Mercedes Axor with OM457LA engine, Euro IV, 295 KW. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für Mercedes Axor mit OM457LA Motor, Euro IV, 295 KW. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2025-11-15",
    popularity: 88,
    image: mercedesDefault,
  },
  {
    id: "3",
    slug: "mercedes-axor-a0734479440-0734479440",
    title: "Mercedes Axor A0734479440 0734479440",
    manufacturer: "Mercedes-Benz",
    model: "Axor",
    euro: "IV",
    engine: "OM457LA",
    kw: 295,
    sku: "A0734479440",
    otherReferences: "0734479440",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika do Mercedes Axor z silnikiem OM457LA, Euro IV, 295 KW. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for Mercedes Axor with OM457LA engine, Euro IV, 295 KW. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für Mercedes Axor mit OM457LA Motor, Euro IV, 295 KW. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2025-10-20",
    popularity: 72,
    image: mercedesDefault,
  },
  {
    id: "4",
    slug: "mercedes-axor-a0734472640-0734472640",
    title: "Mercedes Axor A0734472640 0734472640",
    manufacturer: "Mercedes-Benz",
    model: "Axor",
    euro: "III",
    engine: "OM457LA",
    kw: 260,
    sku: "A0734472640",
    otherReferences: "0734472640",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika do Mercedes Axor z silnikiem OM457LA, Euro III, 260 KW. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for Mercedes Axor with OM457LA engine, Euro III, 260 KW. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für Mercedes Axor mit OM457LA Motor, Euro III, 260 KW. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2025-09-10",
    popularity: 80,
    image: mercedesDefault,
  },
  {
    id: "5",
    slug: "mercedes-actros-a5414465140-5414465140",
    title: "Mercedes Actros A0104460040 0104460040",
    manufacturer: "Mercedes-Benz",
    model: "Actros",
    euro: "II",
    engine: "OM501LA",
    kw: 230,
    sku: "A5414465140",
    otherReferences: "5414465140",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika do Mercedes Actros z silnikiem OM501LA, Euro II, 230 KW. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for Mercedes Actros with OM501LA engine, Euro II, 230 KW. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für Mercedes Actros mit OM501LA Motor, Euro II, 230 KW. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2025-08-05",
    popularity: 91,
    image: mercedesDefault,
  },
  {
    id: "6",
    slug: "mercedes-actros-a5414473240-5414473240",
    title: "Mercedes Actros A5414473240 5414473240",
    manufacturer: "Mercedes-Benz",
    model: "Actros",
    euro: "III",
    engine: "OM501LA",
    kw: 265,
    sku: "A5414473240",
    otherReferences: "5414473240",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika do Mercedes Actros z silnikiem OM501LA, Euro II, 265 KW. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for Mercedes Actros with OM501LA engine, Euro II, 265 KW. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für Mercedes Actros mit OM501LA Motor, Euro II, 265 KW. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-01-07",
    popularity: 90,
    image: mercedesDefault,
  },
  {
    id: "7",
    slug: "man-edc-0281001761-51-11616-1005",
    title: "MAN EDC 0281001761 51.11616-1005",
    manufacturer: "MAN",
    model: "TGA",
    euro: "III",
    engine: "MAN D",
    kw: 265,
    sku: "0281001761",
    otherReferences: "51.11616-1005",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU, Euro III, 265 KW. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN, Euro III, 265 KW. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN, Euro III, 265 KW. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-01-08",
    popularity: 88,
    image: manDefault,
  },
  {
    id: "8",
    slug: "man-edc-0281001747-51-11616-7016",
    title: "MAN EDC 0281001747 51-11616-7016",
    manufacturer: "MAN",
    model: "F2000",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281001747",
    otherReferences: "51.11616-7016",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-01-08",
    popularity: 88,
    image: manDefault,
  },
  {
    id: "9",
    slug: "man-edc-0281001747-51-11616-7055",
    title: "MAN EDC 0281001747 51-11616-7055",
    manufacturer: "MAN",
    model: "F2000",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281001747",
    otherReferences: "51.11616-7055",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-01-08",
    popularity: 88,
    image: manDefault,
  },
  {
    id: "10",
    slug: "man-edc-0281001276-51-11610-7110",
    title: "MAN EDC 0281001276 51-11610-7110",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281001276",
    otherReferences: "51.11610-7110",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-01-08",
    popularity: 88,
    image: manDefault,
  },
  {
    id: "11",
    slug: "man-edc-0281001276-51-11615-7003",
    title: "MAN EDC 0281001276 51-11615-7003",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281001276",
    otherReferences: "51.11615-7003",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-01-08",
    popularity: 61,
    image: manDefault,
  },
  {
    id: "12",
    slug: "man-edc-0281001276-51-11615-7024",
    title: "MAN EDC 0281001276 51-11615-7024",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281001276",
    otherReferences: "51.11615-7024",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-01-08",
    popularity: 46,
    image: manDefault,
  },
  {
    id: "13",
    slug: "man-edc-0281001276-51-11610-7110-2",
    title: "MAN EDC 0281001276 51-11610-7110",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281001276",
    otherReferences: "51.11610-7110",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-01-08",
    popularity: 38,
    image: manDefault,
  },
  {
    id: "14",
    slug: "man-edc-0281001301-51-11615-7015",
    title: "MAN EDC 0281001301 51-11615-7015",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281001301",
    otherReferences: "51.11615-7015",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-01-08",
    popularity: 58,
    image: manDefault,
  },
  {
    id: "15",
    slug: "mercedes-atego-a0644477740-0644477740",
    title: "Mercedes Atego A0644477740 0644477740",
    manufacturer: "Mercedes-Benz",
    model: "Atego",
    euro: "",
    engine: "",
    kw: null,
    sku: "A0644477740",
    otherReferences: "0644477740",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika do Mercedes Atego. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for Mercedes Atego. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für Mercedes Atego. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2025-11-15",
    popularity: 74,
    image: mercedesAtego,
  },
  {
    id: "16",
    slug: "mercedes-atego-a9044464540-9044464540",
    title: "Mercedes Atego A9044464540 9044464540",
    manufacturer: "Mercedes-Benz",
    model: "Atego",
    euro: "",
    engine: "",
    kw: null,
    sku: "A9044464540",
    otherReferences: "9044464540",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika do Mercedes Atego. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for Mercedes Atego. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für Mercedes Atego. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2025-11-15",
    popularity: 72,
    image: mercedesAtego,
  },
  {
    id: "17",
    slug: "mercedes-atego-a9044461240-9044461240",
    title: "Mercedes Atego A9044461240 9044461240",
    manufacturer: "Mercedes-Benz",
    model: "Atego",
    euro: "II",
    engine: "OM904LA",
    kw: 104,
    sku: "A9044461240",
    otherReferences: "9044461240",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika do Mercedes Atego z silnikiem OM904LA, Euro II, 104 KW. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for Mercedes Atego with OM904LA engine, Euro II, 104 KW. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für Mercedes Atego mit OM904LA Motor, Euro II, 104 KW. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2025-11-15",
    popularity: 72,
    image: mercedesAtego,
  },
  {
    id: "18",
    slug: "mercedes-atego-a9044467940-9044467940",
    title: "Mercedes Atego A9044467940 9044467940",
    manufacturer: "Mercedes-Benz",
    model: "Atego",
    euro: "II",
    engine: "OM904LA",
    kw: 110,
    sku: "A9044467940",
    otherReferences: "9044467940",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika do Mercedes Atego z silnikiem OM904LA, Euro II, 110 KW. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for Mercedes Atego with OM904LA engine, Euro II, 110 KW. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für Mercedes Atego mit OM904LA Motor, Euro II, 110 KW. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2025-11-15",
    popularity: 71,
    image: mercedesAtego,
  },
  {
    id: "19",
    slug: "mercedes-atego-a9064465440-9064465440",
    title: "Mercedes Atego A9064465440 9064465440",
    manufacturer: "Mercedes-Benz",
    model: "Atego",
    euro: "II",
    engine: "OM906LA",
    kw: 170,
    sku: "A9064465440",
    otherReferences: "9064465440",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika do Mercedes Atego z silnikiem OM906LA, Euro II, 260 KW. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for Mercedes Atego with OM906LA engine, Euro II, 260 KW. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für Mercedes Atego mit OM906LA Motor, Euro II, 260 KW. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2025-11-15",
    popularity: 72,
    image: mercedesAtego,
  },
  {
    id: "20",
    slug: "mercedes-atego-a9044468740-9044468740",
    title: "Mercedes Atego A9044468740 9044468740",
    manufacturer: "Mercedes-Benz",
    model: "Atego",
    euro: "II",
    engine: "OM904LA",
    kw: 90,
    sku: "A9044468740",
    otherReferences: "9044468740",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika do Mercedes Atego z silnikiem OM904LA, Euro II, 90 KW. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for Mercedes Atego with OM904LA engine, Euro II, 90 KW. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für Mercedes Atego mit OM904LA Motor, Euro II, 90 KW. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2025-11-15",
    popularity: 72,
    image: mercedesAtego,
  },
  {
    id: "21",
    slug: "mercedes-atego-a5414464540-5414464540",
    title: "Mercedes Atego A5414464540 5414464540",
    manufacturer: "Mercedes-Benz",
    model: "Atego",
    euro: "",
    engine: "",
    kw: null,
    sku: "A5414464540",
    otherReferences: "5414464540",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika do Mercedes Atego. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for Mercedes Atego. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für Mercedes Atego. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2025-11-15",
    popularity: 73,
    image: mercedesAtego,
  },
  {
    id: "22",
    slug: "mercedes-actros-a0604485935-0604485935",
    title: "Mercedes Actros A0604486235 0604486235",
    manufacturer: "Mercedes-Benz",
    model: "Actros",
    euro: "",
    engine: "",
    kw: null,
    sku: "A0604485935",
    otherReferences: "0604485935",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika do Mercedes Actros. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for Mercedes Actros. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für Mercedes Actros. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2025-08-05",
    popularity: 74,
    image: mercedesDefault,
  },
  {
    id: "23",
    slug: "mercedes-actros-a0264486835-0264486835",
    title: "Mercedes Actros A0264486835 0264486835",
    manufacturer: "Mercedes-Benz",
    model: "Actros",
    euro: "",
    engine: "",
    kw: null,
    sku: "A0264486835",
    otherReferences: "0264486835",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika do Mercedes Actros. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for Mercedes Actros. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für Mercedes Actros. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2025-08-05",
    popularity: 74,
    image: mercedesDefault,
  },
  {
    id: "24",
    slug: "mercedes-actros-a0004464054-0004464054",
    title: "Mercedes Actros A0004464054 0004464054",
    manufacturer: "Mercedes-Benz",
    model: "Actros",
    euro: "",
    engine: "",
    kw: null,
    sku: "A0264486835",
    otherReferences: "0264486835",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika do Mercedes Actros. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for Mercedes Actros. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für Mercedes Actros. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2025-08-05",
    popularity: 64,
    image: mercedesDefault,
  },
  {
    id: "25",
    slug: "mercedes-actros-a0004463954-0004463954",
    title: "Mercedes Actros A0004463954 0004463954",
    manufacturer: "Mercedes-Benz",
    model: "Actros",
    euro: "",
    engine: "",
    kw: null,
    sku: "A0004463954",
    otherReferences: "0004463954",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika do Mercedes Actros. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for Mercedes Actros. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für Mercedes Actros. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2025-08-05",
    popularity: 61,
    image: mercedesDefault,
  },
{
    id: "26",
    slug: "man-edc-0281020024-51-11616-7178",
    title: "MAN EDC 0281020024 51.11616-7178",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020024",
    otherReferences: "51.11616-7178",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "27",
    slug: "man-edc-0281020055-51-25803-7110",
    title: "MAN EDC 0281020055 51.25803-7110",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020055",
    otherReferences: "51.25803-7110",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "28",
    slug: "man-edc-0281020055-51-25803-7126",
    title: "MAN EDC 0281020055 51.25803-7126",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020055",
    otherReferences: "51.25803-7126",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "29",
    slug: "man-edc-0281020056-51-25803-7081",
    title: "MAN EDC 0281020056 51.25803-7081",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020056",
    otherReferences: "51.25803-7081",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "30",
    slug: "man-edc-0281020056-51-25803-7119",
    title: "MAN EDC 0281020056 51.25803-7119",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020056",
    otherReferences: "51.25803-7119",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "31",
    slug: "man-edc-0281020067-51-25803-1008",
    title: "MAN EDC 0281020067 51.25803-1008",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-1008",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "32",
    slug: "man-edc-0281020067-51-25803-7328",
    title: "MAN EDC 0281020067 51.25803-7328",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7328",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "33",
    slug: "man-edc-0281020067-51-25803-7393",
    title: "MAN EDC 0281020067 51.25803-7393",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7393",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "34",
    slug: "man-edc-0281020067-51-25803-7396",
    title: "MAN EDC 0281020067 51.25803-7396",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7396",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "35",
    slug: "man-edc-0281020067-51-25803-7397",
    title: "MAN EDC 0281020067 51.25803-7397",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7397",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "36",
    slug: "man-edc-0281020067-51-25803-7398",
    title: "MAN EDC 0281020067 51.25803-7398",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7398",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "37",
    slug: "man-edc-0281020067-51-25803-7403",
    title: "MAN EDC 0281020067 51.25803-7403",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7403",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "38",
    slug: "man-edc-0281020067-51-25803-7473",
    title: "MAN EDC 0281020067 51.25803-7473",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7473",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "39",
    slug: "man-edc-0281020067-51-25803-7474",
    title: "MAN EDC 0281020067 51.25803-7474",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7474",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "40",
    slug: "man-edc-0281020067-51-25803-7476",
    title: "MAN EDC 0281020067 51.25803-7476",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7476",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "41",
    slug: "man-edc-0281020067-51-25803-7539",
    title: "MAN EDC 0281020067 51.25803-7539",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7539",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "42",
    slug: "man-edc-0281020067-51-25803-7543",
    title: "MAN EDC 0281020067 51.25803-7543",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7543",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "43",
    slug: "man-edc-0281020067-51-25803-7547",
    title: "MAN EDC 0281020067 51.25803-7547",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7547",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "44",
    slug: "man-edc-0281020067-51-25803-7564",
    title: "MAN EDC 0281020067 51.25803-7564",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7564",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "45",
    slug: "man-edc-0281020067-51-25803-7593",
    title: "MAN EDC 0281020067 51.25803-7593",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7593",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "46",
    slug: "man-edc-0281020067-51-25803-7668",
    title: "MAN EDC 0281020067 51.25803-7668",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7668",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "47",
    slug: "man-edc-0281020067-51-25803-7669",
    title: "MAN EDC 0281020067 51.25803-7669",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7669",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "48",
    slug: "man-edc-0281020067-51-25803-7674",
    title: "MAN EDC 0281020067 51.25803-7674",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7674",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "49",
    slug: "man-edc-0281020067-51-25803-7675",
    title: "MAN EDC 0281020067 51.25803-7675",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7675",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "50",
    slug: "man-edc-0281020067-51-25803-7682",
    title: "MAN EDC 0281020067 51.25803-7682",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7682",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "51",
    slug: "man-edc-0281020067-51-25803-7683",
    title: "MAN EDC 0281020067 51.25803-7683",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7683",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "52",
    slug: "man-edc-0281020067-51-25803-7715",
    title: "MAN EDC 0281020067 51.25803-7715",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7715",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "53",
    slug: "man-edc-0281020067-51-25803-7778",
    title: "MAN EDC 0281020067 51.25803-7778",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7778",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "54",
    slug: "man-edc-0281020067-51-25803-7832",
    title: "MAN EDC 0281020067 51.25803-7832",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7832",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "55",
    slug: "man-edc-0281020067-51-25803-7990",
    title: "MAN EDC 0281020067 51.25803-7990",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7990",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "56",
    slug: "man-edc-0281010255-51-25803-7062",
    title: "MAN EDC 0281010255 51.25803-7062",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281010255",
    otherReferences: "51.25803-7062",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "57",
    slug: "man-edc-0281010255-51-25803-7063",
    title: "MAN EDC 0281010255 51.25803-7063",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281010255",
    otherReferences: "51.25803-7063",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "58",
    slug: "man-edc-0281010255-51-25803-7064",
    title: "MAN EDC 0281010255 51.25803-7064",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281010255",
    otherReferences: "51.25803-7064",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "59",
    slug: "man-edc-0281010255-51-25803-7081",
    title: "MAN EDC 0281010255 51.25803-7081",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281010255",
    otherReferences: "51.25803-7081",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "60",
    slug: "man-edc-0281010255-51-25803-7085",
    title: "MAN EDC 0281010255 51.25803-7085",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281010255",
    otherReferences: "51.25803-7085",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "61",
    slug: "man-edc-0281010255-51-25803-7112",
    title: "MAN EDC 0281010255 51.25803-7112",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281010255",
    otherReferences: "51.25803-7112",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "62",
    slug: "man-edc-0281010255-51-25803-7113",
    title: "MAN EDC 0281010255 51.25803-7113",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281010255",
    otherReferences: "51.25803-7113",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
{
    id: "63",
    slug: "man-edc7-51258037074-51-25803-7074",
    title: "MAN EDC7 51258037074 51.25803-7074",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258037074",
    otherReferences: "51.25803-7074",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
{
    id: "64",
    slug: "man-edc-0281020067-51-25820-1001",
    title: "MAN EDC 0281020067 51.25820-1001",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25820-1001",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "65",
    slug: "man-edc-0281020067-51-25833-7008",
    title: "MAN EDC 0281020067 51.25833-7008",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25833-7008",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "66",
    slug: "man-edc-0281020067-51-25833-7074",
    title: "MAN EDC 0281020067 51.25833-7074",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25833-7074",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "67",
    slug: "man-edc-0281020080-51-25803-7127",
    title: "MAN EDC 0281020080 51.25803-7127",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020080",
    otherReferences: "51.25803-7127",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "68",
    slug: "man-edc-0281020080-51-25803-7233",
    title: "MAN EDC 0281020080 51.25803-7233",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020080",
    otherReferences: "51.25803-7233",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "69",
    slug: "man-edc-0281020131-51-25803-7979",
    title: "MAN EDC 0281020131 51.25803-7979",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020131",
    otherReferences: "51.25803-7979",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "70",
    slug: "man-edc-0281020131-51-25820-1009",
    title: "MAN EDC 0281020131 51.25820-1009",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020131",
    otherReferences: "51.25820-1009",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "71",
    slug: "man-edc-0281020131-51-25833-7198",
    title: "MAN EDC 0281020131 51.25833-7198",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020131",
    otherReferences: "51.25833-7198",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "72",
    slug: "man-edc-0281020131-51-25833-7202",
    title: "MAN EDC 0281020131 51.25833-7202",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020131",
    otherReferences: "51.25833-7202",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "73",
    slug: "man-edc-0281020131-51-25833-7203",
    title: "MAN EDC 0281020131 51.25833-7203",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020131",
    otherReferences: "51.25833-7203",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "74",
    slug: "man-edc-0281020131-51-25833-7525",
    title: "MAN EDC 0281020131 51.25833-7525",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020131",
    otherReferences: "51.25833-7525",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "75",
    slug: "man-edc-0281020131-51-25833-7542",
    title: "MAN EDC 0281020131 51.25833-7542",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020131",
    otherReferences: "51.25833-7542",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "76",
    slug: "man-edc-0281020176-51-25820-1017",
    title: "MAN EDC 0281020176 51.25820-1017",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020176",
    otherReferences: "51.25820-1017",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "77",
    slug: "man-edc-0281020373-51-25820-1024",
    title: "MAN EDC 0281020373 51.25820-1024",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020373",
    otherReferences: "51.25820-1024",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "78",
    slug: "man-edc-0281020444-51-25820-1028",
    title: "MAN EDC 0281020444 51.25820-1028",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020444",
    otherReferences: "51.25820-1028",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "79",
    slug: "man-edc17-0281020273-51-25804-0212",
    title: "MAN EDC17 0281020273 51.25804-0212",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020273",
    otherReferences: "51.25804-0212",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "80",
    slug: "man-edc17-0281020273-51-25804-0217",
    title: "MAN EDC17 0281020273 51.25804-0217",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020273",
    otherReferences: "51.25804-0217",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "81",
    slug: "man-edc17-0281020273-51-25804-0380",
    title: "MAN EDC17 0281020273 51.25804-0380",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020273",
    otherReferences: "51.25804-0380",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "82",
    slug: "man-edc17-0281020273-51-25804-0381",
    title: "MAN EDC17 0281020273 51.25804-0381",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020273",
    otherReferences: "51.25804-0381",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "83",
    slug: "man-edc17-0281020273-51-25804-0823",
    title: "MAN EDC17 0281020273 51.25804-0823",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020273",
    otherReferences: "51.25804-0823",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "84",
    slug: "man-edc17-0281020273-51-25804-0824",
    title: "MAN EDC17 0281020273 51.25804-0824",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020273",
    otherReferences: "51.25804-0824",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "85",
    slug: "man-edc17-0281020273-51-25804-0889",
    title: "MAN EDC17 0281020273 51.25804-0889",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020273",
    otherReferences: "51.25804-0889",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "86",
    slug: "man-edc17-0281020273-51-25804-7380",
    title: "MAN EDC17 0281020273 51.25804-7380",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020273",
    otherReferences: "51.25804-7380",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "87",
    slug: "man-edc17-0281020273-51-25804-7381",
    title: "MAN EDC17 0281020273 51.25804-7381",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020273",
    otherReferences: "51.25804-7381",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "88",
    slug: "man-edc17-0281020273-51-25804-7778",
    title: "MAN EDC17 0281020273 51.25804-7778",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020273",
    otherReferences: "51.25804-7778",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "89",
    slug: "man-edc17-0281020273-51-25835-0047",
    title: "MAN EDC17 0281020273 51.25835-0047",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020273",
    otherReferences: "51.25835-0047",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "90",
    slug: "man-edc17-0281020273-51-25835-0048",
    title: "MAN EDC17 0281020273 51.25835-0048",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020273",
    otherReferences: "51.25835-0048",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "91",
    slug: "man-edc17-0281020273-51-25835-0326",
    title: "MAN EDC17 0281020273 51.25835-0326",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020273",
    otherReferences: "51.25835-0326",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "92",
    slug: "man-edc17-0281020273-51-25835-7326",
    title: "MAN EDC17 0281020273 51.25835-7326",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020273",
    otherReferences: "51.25835-7326",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "93",
    slug: "man-edc17-0281020592-51-25835-3553",
    title: "MAN EDC17 0281020592 51.25835-3553",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020592",
    otherReferences: "51.25835-3553",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "94",
    slug: "man-edc7-0281020067-51-25803-7538",
    title: "MAN EDC7 0281020067 51.25803-7538",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7538",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "95",
    slug: "man-edc7-0281020067-51-25803-7544",
    title: "MAN EDC7 0281020067 51.25803-7544",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7544",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "96",
    slug: "man-edc7-0281020067-51-25803-7563",
    title: "MAN EDC7 0281020067 51.25803-7563",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7563",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "97",
    slug: "man-edc7-0281020067-51-25803-7860",
    title: "MAN EDC7 0281020067 51.25803-7860",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281020067",
    otherReferences: "51.25803-7860",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "98",
    slug: "man-edc7-51258037050-51-25803-7050",
    title: "MAN EDC7 51258037050 51.25803-7050",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258037050",
    otherReferences: "51.25803-7050",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
  {
    id: "99",
    slug: "man-edc7-51258037052-51-25803-7052",
    title: "MAN EDC7 51258037052 51.25803-7052",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258037052",
    otherReferences: "51.25803-7052",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-27",
    popularity: Math.floor(Math.random() * 100) + 1,
    image: manDefault,
  },
{
    id: "100",
    slug: "man-edc7-51258037111-51-25803-7111",
    title: "MAN EDC7 51258037111 51.25803-7111",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258037111",
    otherReferences: "51.25803-7111",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 43,
    image: manDefault,
  },
  {
    id: "101",
    slug: "man-edc7-51258037196-51-25803-7196",
    title: "MAN EDC7 51258037196 51.25803-7196",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258037196",
    otherReferences: "51.25803-7196",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 71,
    image: manDefault,
  },
  {
    id: "102",
    slug: "man-edc7-51258037214-51-25803-7214",
    title: "MAN EDC7 51258037214 51.25803-7214",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258037214",
    otherReferences: "51.25803-7214",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 27,
    image: manDefault,
  },
  {
    id: "103",
    slug: "man-edc7-51258037341-51-25803-7341",
    title: "MAN EDC7 51258037341 51.25803-7341",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258037341",
    otherReferences: "51.25803-7341",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 62,
    image: manDefault,
  },
  {
    id: "104",
    slug: "man-edc7-51258037378-51-25803-7378",
    title: "MAN EDC7 51258037378 51.25803-7378",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258037378",
    otherReferences: "51.25803-7378",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 35,
    image: manDefault,
  },
  {
    id: "105",
    slug: "man-edc7-51258037399-51-25803-7399",
    title: "MAN EDC7 51258037399 51.25803-7399",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258037399",
    otherReferences: "51.25803-7399",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 89,
    image: manDefault,
  },
  {
    id: "106",
    slug: "man-edc7-51258037493-51-25803-7493",
    title: "MAN EDC7 51258037493 51.25803-7493",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258037493",
    otherReferences: "51.25803-7493",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 54,
    image: manDefault,
  },
  {
    id: "107",
    slug: "man-edc7-51258037545-51-25803-7545",
    title: "MAN EDC7 51258037545 51.25803-7545",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258037545",
    otherReferences: "51.25803-7545",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 18,
    image: manDefault,
  },
  {
    id: "108",
    slug: "man-edc7-51258037582-51-25803-7582",
    title: "MAN EDC7 51258037582 51.25803-7582",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258037582",
    otherReferences: "51.25803-7582",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 76,
    image: manDefault,
  },
  {
    id: "109",
    slug: "man-edc7-51258037664-51-25803-7664",
    title: "MAN EDC7 51258037664 51.25803-7664",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258037664",
    otherReferences: "51.25803-7664",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 41,
    image: manDefault,
  },
  {
    id: "110",
    slug: "man-edc7-51258037801-51-25803-7801",
    title: "MAN EDC7 51258037801 51.25803-7801",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258037801",
    otherReferences: "51.25803-7801",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 93,
    image: manDefault,
  },
  {
    id: "111",
    slug: "man-edc7-51258037833-51-25803-7833",
    title: "MAN EDC7 51258037833 51.25803-7833",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258037833",
    otherReferences: "51.25803-7833",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 29,
    image: manDefault,
  },
  {
    id: "112",
    slug: "man-edc7-5125807269-51-25803-7269",
    title: "MAN EDC7 5125807269 51.25803-7269",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "5125807269",
    otherReferences: "51.25803-7269",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 67,
    image: manDefault,
  },
  {
    id: "113",
    slug: "man-edc7-51258337091-51-25833-7091",
    title: "MAN EDC7 51258337091 51.25833-7091",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258337091",
    otherReferences: "51.25833-7091",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 52,
    image: manDefault,
  },
  {
    id: "114",
    slug: "man-edc7-51258337182-51-25833-7182",
    title: "MAN EDC7 51258337182 51.25833-7182",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258337182",
    otherReferences: "51.25833-7182",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 38,
    image: manDefault,
  },
  {
    id: "115",
    slug: "man-edc7-51258337393-51-25833-7393",
    title: "MAN EDC7 51258337393 51.25833-7393",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258337393",
    otherReferences: "51.25833-7393",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 81,
    image: manDefault,
  },
  {
    id: "116",
    slug: "man-edc7-51258337556-51-25833-7556",
    title: "MAN EDC7 51258337556 51.25833-7556",
    manufacturer: "MAN",
    model: "",
    euro: "",
    engine: "",
    kw: null,
    sku: "51258337556",
    otherReferences: "51.25833-7556",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 47,
    image: manDefault,
  },
  {
    id: "117",
    slug: "man-jelcz-0281001476-51-11615-7062",
    title: "MAN JELCZ 0281001476 51.11615-7062",
    manufacturer: "MAN",
    model: "Jelcz",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281001476",
    otherReferences: "51.11615-7062",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 64,
    image: manDefault,
  },
  {
    id: "118",
    slug: "man-neoplan-0281010013-51-11610-7139",
    title: "MAN NEOPLAN 0281010013 51.11610-7139",
    manufacturer: "MAN",
    model: "Neoplan",
    euro: "",
    engine: "",
    kw: null,
    sku: "0281010013",
    otherReferences: "51.11610-7139",
    category: "Sterowniki silnika",
    description: {
      pl: "Sterownik silnika MAN ECU. Część oryginalna, sprawdzona i gotowa do montażu.",
      en: "Engine ECU for MAN. Original part, tested and ready for installation.",
      de: "Motorsteuergerät für MAN. Originalteil, geprüft und einbaufertig.",
    },
    createdAt: "2026-03-29",
    popularity: 22,
    image: manDefault,
  },



];

export const manufacturers = ["Mercedes-Benz", "MAN"] as const;

export const categories = [
  "Sterowniki silnika",
  "Sterowniki skrzyni biegów",
  "Sterowniki ABS/EBS",
  "Sterowniki klimatyzacji",
] as const;

export const models: Record<string, string[]> = {
  "Mercedes-Benz": ["Actros", "Axor", "Atego", "Arocs", "Econic"],
  MAN: ["TGA", "TGS", "TGX", "TGM", "TGL", "F2000", "Jelcz", "Neoplan"],
};
